/*企业管理*/

import {axiospost,axiosget} from './axios';

//门店管理--获取门店列表
export const getDeptList = (params) =>axiosget('/sys/businessManage/getDeptList',params)
//门店管理--获取门店下拉列表
export const getAntDeptSelect = () =>axiosget('/sys/businessManage/getAntDeptSelect')
//门店管理--创建门店
export const addDept = (params) =>axiospost('/sys/businessManage/addDept',params)
//门店管理--通过id获取门店详细信息
export const getDeptById = (params) =>axiosget('/sys/businessManage/getDeptById',params)
//门店管理--修改门店信息
export const updateDept = (params) =>axiospost('/sys/businessManage/updateDept',params)
//门店管理--删除门店
export const deleteDeptById = (params) =>axiosget('/sys/businessManage/deleteDeptById',params)


//账号管理--列表
export const getCountList = (params) =>axiosget('/sys/businessManage/getCountList',params)
//账号管理--添加
export const addUser = (params) =>axiospost('/sys/businessManage/addUser',params)
//账号管理--获取详情
export const getUserById = (params) =>axiosget('/sys/businessManage/getUserById',params)
//账号管理--编辑
export const updateUser = (params) =>axiospost('/sys/businessManage/updateUser',params)
//账号管理--账号管理--重置密码
export const initPassword = (params) =>axiosget('/sys/businessManage/initPassword',params)
//账号管理--删除(注销)
export const deleteUser = (params) =>axiosget('/sys/businessManage/deleteUser',params)



//角色管理--获取角色下拉列表
export const getRolesSelect = () =>axiosget('/sys/businessManage/getRolesSelect')
//角色管理--分页查询角色列表
export const getRoleList = () =>axiosget('/sys/businessManage/getRoleList')




//会员等级--获取会员等级下拉列表
export const getMembersCardLevelSelect = () =>axiosget('/sys/businessManage/getMembersCardLevelSelect')
//会员等级--分页查询会员卡等级
export const getMembersLevelPage = (params) =>axiosget('/sys/businessManage/getMembersLevelPage',params)
//会员等级--添加会员卡等级
export const addMembersCardLevel = (params) =>axiospost('/sys/businessManage/addMembersCardLevel',params)
//会员等级--通过id查询详情
export const getMembersLevelById = (params) =>axiosget('/sys/businessManage/getMembersLevelById',params)
//会员等级--编辑会员卡等级
export const updateMembersCardLevel = (params) =>axiospost('/sys/businessManage/updateMembersCardLevel',params)

//企业管理--会员荣耀列表
export const getHonourList = () =>axiosget('/sys/businessManage/getHonourList')
//企业管理--添加会员荣耀
export const addHonour = (params) =>axiospost('/sys/businessManage/addHonour',params)
//企业管理--删除会员荣耀
export const deleteHonour = (params) =>axiosget('/sys/businessManage/deleteHonour',params)

//会员管理--通过id获得会员详情
export const getAntMemberById = (params) =>axiosget('/sys/membersManagement/getAntMemberById',params)
//会员管理--编辑会员
export const updateMember = (params) =>axiospost('/sys/membersManagement/updateMember',params)
//会员管理--会员信息变动流水
export const getAntMembersChangePage = (params) =>axiosget('/sys/membersManagement/getAntMembersChangePage',params)

//企业管理--根据类型获取会员或积分规则
export const getRuleUrlByType = (params) =>axiosget('/sys/businessManage/getRuleUrlByType',params)
//企业管理--修改会员积分规则
export const updateRulesUrl = (params) =>axiospost('/sys/businessManage/updateRulesUrl',params)

//企业管理--添加规则
export const addRulesUrl = (params) =>axiospost('/sys/businessManage/addRulesUrl',params)
//企业管理--获取规则列表
export const getRulesPage = (params) =>axiosget('/sys/businessManage/getRulesPage',params)
//企业管理--修改规则
export const updateRulesUrlSecond = (params) =>axiospost('/sys/businessManage/updateRulesUrl',params)
//企业管理--规则详情
export const getRuleById = (params) =>axiosget('/sys/businessManage/getRuleById',params)
//企业管理--规则删除
export const deleteRuleById = (params) =>axiospost('/sys/businessManage/deleteRuleById',params)

//会员日志-流水类型字典
export const memberInfoChange = () => axiosget('/sys/dict/getDictItems/member_info_change')


//会员删除
export const deleteMembers = (params) => axiospost('/sys/membersManagement/deleteMembers',params)

//箭票后台设置可以关闭或者打开转增功能/查询
export const getSysConfig = (params) => axiosget('/sys/sysConfig/getSysConfig',params)


//箭票后台设置可以关闭或者打开转增功能/修改
export const updateSysCOnfig = (params) => axiospost('/sys/sysConfig/updateSysCOnfig',params)